import { withTheme } from '@emotion/react';
import classNames from 'classnames';
import HighlightText from 'components/HighlightText';
import Downshift from 'downshift';
import PropTypes from 'prop-types';
/* eslint react/prop-types: 0 */
import React, { PureComponent } from 'react';
import compose from 'utils/compose';

import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import TextField from '@mui/material/TextField';
import { getStandardDrawerFloatingSx, useStandardDrawerLayerContainer } from 'components/Drawers/StandardDrawer';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
  fullWidth: {
    width: '100%',
  },
});

const noPadding = { padding: 0 };

class DownshiftField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { ignoreFilter: false };
  }

  keyDown = (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
    }
  };

  eatFocus = (_event) => {
    this.anchorEl?.focus();
  };

  render() {
    const { classes, textFieldProps, InputProps, plain, sharedcomponentid, disabled } = this.props;
    return (
      <>
        {this.props.dataLoading ? (
          <>
            {plain ? (
              <InputBase
                {...textFieldProps?.InputProps}
                {...InputProps}
                variant='paragraphRegular'
                margin='none'
                value={this.props.initialInputValue}
                sharedcomponentid={'DOWNSHIFT_FIELD'}
                disabled
                // endAdornment={
                //   <InputAdornment variant="filled" position="end">
                //     <CircularProgress size={20} />
                //   </InputAdornment>
                // }
              />
            ) : (
              <TextField
                {...textFieldProps}
                value={this.props.initialInputValue}
                sharedcomponentid={sharedcomponentid || 'DOWNSHIFT_FIELD'}
                variant='filled'
                disabled
                InputProps={{
                  ...InputProps,
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <CircularProgress size={20} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </>
        ) : (
          <Downshift
            defaultHighlightedIndex={0}
            initialHighlightedIndex={this.props.items.indexOf(this.props.initialItemSelected)}
            initialInputValue={
              this.props.initialInputValue ||
              (this.props.initialItemSelected ? this.props.itemToString(this.props.initialItemSelected) : '')
            }
            initialSelectedItem={this.props.initialItemSelected}
            onChange={(item) => this.props.onSelected && this.props.onSelected(item)}
            onInputValueChange={(inputValue) => {
              this.state.ignoreFilter && this.setState({ ignoreFilter: false });
              this.props.onInputValueChange && this.props.onInputValueChange(inputValue);
            }}
            itemToString={this.props.itemToString}
            stateReducer={(state, changes) => {
              let changesApproved = changes;
              switch (changes.type) {
                case Downshift.stateChangeTypes.blurInput:
                case Downshift.stateChangeTypes.mouseUp:
                  if (this.props.allowNonListedItems) {
                    changesApproved = {
                      ...changes,
                      inputValue: state.inputValue,
                    };
                  } else {
                    changesApproved = {
                      ...changes,
                      ...(changes.inputValue === null ? { inputValue: '' } : undefined),
                    };
                  }
                  break;
                default:
                  changesApproved = changes;
              }
              return changesApproved;
            }}
            id={textFieldProps?.id}
          >
            {({
              getInputProps,
              getItemProps,
              getMenuProps,
              isOpen,
              inputValue,
              highlightedIndex,
              toggleMenu,
              selectItemAtIndex,
              getRootProps,
            }) => {
              const inputValueLowerCase = inputValue && inputValue.toLowerCase();
              const filteredItems = this.state.ignoreFilter
                ? this.props.items
                : this.props.items &&
                  this.props.items.filter(
                    (item) => !inputValue || this.props.itemToString(item).toLowerCase().includes(inputValueLowerCase),
                  );
              const { value, ...inputProps } = textFieldProps?.InputProps || {};
              return (
                <div
                  sharedcomponentid={sharedcomponentid || 'DOWNSHIFT_FIELD'}
                  className={classNames(
                    textFieldProps?.fullWidth ? classes.fullWidth : undefined,
                    this.props.className,
                  )}
                  {...getRootProps(
                    {
                      role: 'presentation',
                      onKeyDown: isOpen ? this.keyDown : undefined,
                    },
                    { suppressRefError: true },
                  )}
                >
                  {plain ? (
                    <InputBase
                      {...getInputProps({
                        endAdornment: (
                          <InputAdornment variant='filled' position='end'>
                            <IconButton
                              style={noPadding}
                              aria-label='toggle options'
                              // make not focusable
                              tabIndex={-1}
                              // make not focusable
                              onFocus={this.eatFocus}
                              size='large'
                            >
                              {isOpen ? <ArrowDropUpRoundedIcon /> : <ArrowDropDownRoundedIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                        ...inputProps,
                        ...InputProps,
                        onKeyDown: (event) => {
                          if (isOpen) {
                            if (event.key === 'Tab' || event.key === 'Enter') {
                              if (!highlightedIndex && this.props.initialItemSelected !== inputValue) {
                                selectItemAtIndex(0);
                                event.stopPropagation();
                              } else if (highlightedIndex) {
                                selectItemAtIndex(highlightedIndex);
                                event.stopPropagation();
                              }
                            }
                          }
                        },
                        onClick: () => {
                          this.setState({ ignoreFilter: true });
                          toggleMenu();
                        },
                      })}
                      inputRef={(node) => {
                        this.anchorEl = node;
                      }}
                      variant='paragraphRegular'
                      margin='none'
                      sharedcomponentid={'DOWNSHIFT_FIELD'}
                    />
                  ) : (
                    <TextField
                      variant='filled'
                      {...textFieldProps}
                      inputRef={(node) => {
                        this.anchorEl = node;
                      }}
                      InputProps={{
                        ...getInputProps({
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                style={{ padding: 0 }}
                                aria-label='toggle options'
                                // make not focusable
                                tabIndex={-1}
                                // make not focusable
                                onFocus={(_event) => this.anchorEl?.focus()}
                                size='large'
                                disabled={disabled}
                              >
                                {isOpen ? <ArrowDropUpRoundedIcon /> : <ArrowDropDownRoundedIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          ...inputProps,
                          ...InputProps,
                          onKeyDown: (event) => {
                            if (isOpen) {
                              if (event.key === 'Tab' || event.key === 'Enter') {
                                if (!highlightedIndex && this.props.initialItemSelected !== inputValue) {
                                  selectItemAtIndex(0);
                                  event.stopPropagation();
                                } else if (highlightedIndex) {
                                  selectItemAtIndex(highlightedIndex);
                                  event.stopPropagation();
                                }
                              }
                            }
                          },
                          onClick: () => {
                            if (!disabled) {
                              this.setState({ ignoreFilter: true });
                              toggleMenu();
                            }
                          },
                        }),
                      }}
                    />
                  )}

                  {isOpen && filteredItems && filteredItems.length > 0 && (
                    <Popper
                      container={this.props.drawerLayerContainer}
                      open
                      anchorEl={this.anchorEl}
                      placement='bottom-start'
                      sx={this.props.drawerFloatingSx}
                    >
                      <div {...getMenuProps({}, { suppressRefError: true })}>
                        <Paper>
                          <MenuList
                            style={{
                              maxHeight: 320,
                              overflowY: 'auto',
                            }}
                          >
                            {filteredItems.map((item, index) => {
                              const itemString = this.props.itemToString(item);
                              return (
                                <MenuItem
                                  key={this.props.itemKey(item) ?? index}
                                  {...getItemProps({
                                    index,
                                    key: this.props.itemKey(item),
                                    // sorry we can't override 'id' - downshift uses it for internal purpose
                                    item,
                                    selected: index === highlightedIndex,
                                  })}
                                >
                                  <HighlightText
                                    id={(this.props.indexId && `item_${index}`) || this.props.itemKey(item)}
                                    text={itemString}
                                    searchKeys={[inputValue]}
                                  />
                                </MenuItem>
                              );
                            })}
                          </MenuList>
                        </Paper>
                      </div>
                    </Popper>
                  )}
                </div>
              );
            }}
          </Downshift>
        )}
      </>
    );
  }
}

DownshiftField.defaultProps = {
  itemToString: (item) => item,
  itemKey: (item) => item,
  indexId: false,
};

DownshiftField.propTypes = {
  items: PropTypes.array,
  initialItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  initialInputValue: PropTypes.string,
  onSelected: PropTypes.func,
  onInputValueChange: PropTypes.func,
  itemToString: PropTypes.func,
  itemKey: PropTypes.func,
  dataLoading: PropTypes.bool,
  allowNonListedItems: PropTypes.bool,
  indexId: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  textFieldProps: PropTypes.object,
  InputProps: PropTypes.object,
  plain: PropTypes.bool,
  sharedcomponentid: PropTypes.string,
  disabled: PropTypes.bool,
  drawerFloatingSx: PropTypes.object,
  drawerLayerContainer: PropTypes.object,
};

const StyledDownshiftField = compose(withTheme)(withStyles(DownshiftField, styles, { name: { DownshiftField } }));

function DownshiftFieldWithDrawerLayer(props) {
  const drawerFloatingSx = getStandardDrawerFloatingSx();
  const drawerLayerContainer = useStandardDrawerLayerContainer();
  return (
    <StyledDownshiftField {...props} drawerFloatingSx={drawerFloatingSx} drawerLayerContainer={drawerLayerContainer} />
  );
}

export default DownshiftFieldWithDrawerLayer;
